import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SaveIcon from '@material-ui/icons/Save';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';

import AccessGroupsMobile from './AccessGroupsMobile.jsx';
import AddCardMobile from './AddCardMobile.jsx';
import Search from './Search.jsx';

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  banner: {
    marginRight: theme.spacing(2),
  },
  badge: {
    backgroundColor: theme.palette.warning.light,
  },
  divider: {
    borderLeft: `1px solid ${theme.palette.neutral.main}`,
    height: '2em',
    marginLeft: '0.3em',
  },
  profile: {
    padding: '5px 10px 5px 10px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1.3em',
    flexShrink: 0,
  },
  paper: {
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    width: '100%',
  },
  content: {
    marginTop: theme.spacing(1),
  },
  cardholderRecord: {
    display: 'flex',
  },
  half: {
    width: '50%',
    display: 'inline-block',
    verticalAlign: 'top',
    minHeight: '700px',
  },
  firstHalf: {
    borderRight: '1px solid gainsboro',
  },
  secondHalf: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1.2),
    width: '48.5%',
  },
  btn: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  actionWrapper: {
    display: 'flex',
    justifyContent: 'end',
    flexDirection: 'column',
    width: '50%',
    float: 'right',
    top: '-100px',
    position: 'relative',
  },
  dirtyWarning: {
    marginRight: theme.spacing(2),
    textAlign: 'end',
  },
  mobilePage: {
    width: '100%',
    display: 'inline-block',
    verticalAlign: 'top',
    minHeight: '425px',
  },
  credentialsMobile: {
    padding: theme.spacing(3),
  },
  root: {
    flexGrow: 1,
  },
  speedDial: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(2),
    zIndex: 10000,
  },
  drawer: {
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    width: '100%',
    top: '6%',
  },
  formGroup: {
    padding: '2%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignContent: 'stretch',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  formGroup2: {
    paddingLeft: '5%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignContent: 'stretch',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  formLabel: {
    paddingLeft: '2%',
  },
  grid: {
    flexGrow: 1,
  },
  toolTip: {
    width: 'max-content',
  },
  dateTimePicker: {
    minWidth: '330px  !important',
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    boxShadow: 'none',
    position: 'fixed',
  },
}));

// TODO: Add more Actions to Speed Dial

const MobileViewPage = ({
  contentType,
  cardData,
  setCardData,
  mobileOpen,
  setMobileOpen,
  setContentType,
  addCard,
  updateCard,
  deleteCard,
  selectedIndex,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const toolbarBackground = theme.palette.type === 'dark' ? '#1f1f1f' : '#ffffff';
  const toolbarForeground = theme.palette.type === 'dark' ? '#ffffff' : '#43425d';
  const [speedOpen, setSpeedOpen] = useState(false);
  const [pageOptions, setPageOptions] = useState(null);
  const [tempCardData, setTempCardData] = useState(null);
  const [accessGroups, setAccessGroups] = useState(null);

  const handleMobileClose = () => {
    if (pageOptions === 'Access Groups') {
      setPageOptions(null);
    } else if (contentType === 'Edit Card') {
      contentType = 'Add Card';
      setContentType(contentType);
      setTempCardData(null);
      setAccessGroups(null);
      window.scrollTo(0, 1000);
      setMobileOpen(false);
    } else {
      window.scrollTo(0, 1000);
      setMobileOpen(false);
      setTempCardData(null);
    }
  };
  const handleSpeedClose = () => {
    setSpeedOpen(false);
  };

  const handleSpeedOpen = () => {
    setSpeedOpen(true);
  };

  const handleSetContentAG = (event) => {
    const AG = 'Access Groups';
    setTempCardData(cardData);
    if (!accessGroups) {
      if (cardData.accessGroups) {
        const tempAGSDR = {
          accessGroups: cardData.accessGroups,
          singleReaderAccessRights: cardData.singleReaderAccessRights,
        };
        setAccessGroups(tempAGSDR);
      }
    }
    window.scrollTo(0, 0);
    setPageOptions(AG);
    handleSpeedClose(event);
  };

  const handleSaveData = (e) => {
    if (cardData) {
      if (contentType === 'Add Card') {
        if (tempCardData && accessGroups) {
          let newData = {};
          newData = { ...tempCardData, ...accessGroups };
          addCard(newData);
        } else if (tempCardData) {
          addCard(tempCardData);
        } else {
          addCard(cardData);
        }
        handleMobileClose(e);
      } else if (accessGroups) {
        let newData = {};
        newData = { ...cardData, ...accessGroups };
        updateCard(newData);
        handleMobileClose(e);
      } else {
        updateCard(cardData);
        handleMobileClose(e);
      }
    } else {
      handleMobileClose(e);
    }
    setAccessGroups(null);
    setTempCardData(null);
  };

  const handleSaveAccessData = (e) => {
    setPageOptions(null);
    handleSpeedClose(e);
  };

  const handleDeleteCard = (e) => {
    if (cardData) {
      deleteCard(selectedIndex);
      handleMobileClose(e);
    } else {
      handleMobileClose(e);
    }
  };

  const appendCardDataAG = (e) => {
    if (tempCardData) {
      const tempData = tempCardData;
      setAccessGroups(e);
      setTempCardData(tempData);
    } else if (cardData) {
      const tempData = cardData;
      cardData = tempData;
    } else {
      const tempData = {};
      cardData = tempData;
    }
  };

  const appendCardData = (e) => {
    if (accessGroups) {
      let tempData = {};
      tempData = e;
      tempData.accessGroups = accessGroups.accessGroups;
      tempData.singleReaderAccessRights = accessGroups.singleReaderAccessRights;
      setCardData(tempData);
    } else {
      let tempData = {};
      tempData = e;
      setCardData(tempData);
    }
  };

  const actionsAddCard = [
    {
      icon: <AddCircleOutlineIcon />,
      name: 'Assign Access Groups',
      action: handleSetContentAG,
    },
  ];

  const contentController = (content) => {
    const addCard = 'Add Card';
    const addAccess = 'Access Groups';
    const editCard = 'Edit Card';
    switch (content) {
      case addCard:
        return (
          <>
            <AddCardMobile
              cardData={tempCardData || undefined}
              setCardData={setCardData}
              AEData={(e) => appendCardData(e)}
            />
          </>
        );

      case editCard:
        return (
          <>
            <AddCardMobile
              cardData={cardData}
              setCardData={setCardData}
              AEData={(e) => appendCardData(e)}
            />
          </>
        );
      case addAccess:
        return (
          <>
            <AccessGroupsMobile
              AGSDR={accessGroups}
              setAGSDR={setAccessGroups}
              AGData={(e) => appendCardDataAG(e)}
            />
          </>
        );
      default:
        return (
          <>
            <div>
              <Typography>Your Content Would Go Here!</Typography>
            </div>
          </>
        );
    }
  };

  const generateRendering = () => {
    return (
      <div className={classes.content}>
        <form data-testid="cardholderForm" className={classes.container}>
          <Popper
            style={{ position: 'absolute', zIndex: '1100' }}
            transitionDuration="0"
            open={mobileOpen}
            classes={{ paper: classes.drawer }}
          >
            <Paper style={{ height: '200vh', width: '100vw', paddingTop: '10vh' }}>
              <div>
                <AppBar position="fixed" className={classes.appBar}>
                  <Toolbar style={{ backgroundColor: toolbarBackground, color: toolbarForeground }}>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      edge="start"
                      className={classes.menuButton}
                      onClick={handleMobileClose}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <div>
                      <Search isMobile />
                    </div>
                  </Toolbar>
                </AppBar>
              </div>
              <div>
                {/* Insert Component(s) Here */}
                {pageOptions ? contentController(pageOptions) : contentController(contentType)}
                {/* For Future Components to be used:  */}
                {/* {
                  {
                    'Add Card': <AddCardMobile></AddCardMobile>,
                    'Access Groups': <AccessGroupsMobile></AccessGroupsMobile>,
                  }[pageOptions]
                } */}
              </div>
              <div />
            </Paper>
          </Popper>
        </form>
      </div>
    );
  };

  return (
    <>
      <div className={classes.root} style={mobileOpen ? {} : { display: 'none' }}>
        <SpeedDial
          ariaLabel="SpeedDial openIcon example"
          className={classes.speedDial}
          icon={<SpeedDialIcon />}
          onClose={handleSpeedClose}
          onOpen={handleSpeedOpen}
          open={speedOpen}
        >
          {pageOptions || contentType === 'Access Groups' ? (
            <></>
          ) : (
            <SpeedDialAction
              key="Delete"
              icon={<HighlightOffIcon style={{ fill: 'red' }} />}
              tooltipOpen
              tooltipTitle="Delete Card"
              classes={classes.toolTip}
              TooltipClasses={classes.toolTip}
              onClick={handleDeleteCard}
            />
          )}

          {!pageOptions && (contentType === 'Add Card' || contentType === 'Edit Card') ? (
            actionsAddCard.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={action.action}
                classes={classes.toolTip}
                TooltipClasses={classes.toolTip}
                tooltipOpen
              />
            ))
          ) : (
            <></>
          )}

          {pageOptions === 'Access Groups' || contentType === 'Access Groups' ? (
            <SpeedDialAction
              key="Save Access Groups"
              icon={<SaveIcon />}
              tooltipOpen
              tooltipTitle="Save Access Groups"
              classes={classes.toolTip}
              TooltipClasses={classes.toolTip}
              onClick={(e) => {
                handleSaveAccessData(e);
              }}
            />
          ) : (
            <SpeedDialAction
              key="Save Card"
              icon={<SaveIcon />}
              tooltipOpen
              tooltipTitle="Save Card"
              classes={classes.toolTip}
              TooltipClasses={classes.toolTip}
              onClick={(e) => {
                handleSaveData(e);
              }}
            />
          )}
        </SpeedDial>
      </div>

      {generateRendering()}
    </>
  );
};

export default MobileViewPage;
